import {
  FETCH_DELIVERY_PARTNER,
  RESET_DELIVERY_PARTNER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const deliveryPartnerViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_PARTNER:
      return { data: action.payload };
    case RESET_DELIVERY_PARTNER:
      return initialState;
    default:
      return state;
  }
};

export default deliveryPartnerViewReducer;
